import { createFileRoute } from "@tanstack/react-router";
import { EnergiPage, energiHead } from "@/pages/EnergiPage";

export const Route = createFileRoute("/de/branchen/energie-infrastruktur")({
  head: () => energiHead("de"),
  component: () => <EnergiPage locale="de" />,
});
